import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link, Typography } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  link: {
    color: theme.palette.primary.brandPrimary,
    fontWeight: 400,
  },
}));

const CounterHelpText = () => {
  const classes = useStyles();
  return (
    <div>
      <Typography variant="body2">
        The COUNTER system (Counting Online Usage of Networked Electronic
        Resources) is used to track and report usage statistics for digital
        content. It provides a standardized way to analyze and compare how often
        online resources are accessed across different platforms.
      </Typography>
      <Typography variant="body2">
        Many libraries make use of COUNTER for its standardized format, but it
        may be new for some. If you have any questions about COUNTER, please
        check out{" "}
        <Link
          className={classes.link}
          underline="always"
          target="_blank"
          href="https://www.countermetrics.org/education/"
        >
          this resource.
        </Link>
      </Typography>
    </div>
  );
};

export default CounterHelpText;
